import { IncludedGuarantees } from "./components/IncludedGuarantees/IncludedGuarantees";
import { DeliveryHighlights } from "./components/DeliveryHighlights/DeliveryHighlights";
import styles from "./DeliveryAndGuaranteesMessage.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export type Props = {
  /**
   * A string representing the message.
   */
  message: string;
  /**
   * A boolean indicating whether click and collect is available for selected variant.
   */
  isClickAndCollectAvailable: boolean;
  /**
   * A boolean indicating whether price of the product is above the click and collect threshold.
   */
  isOverClickAndCollectThreshold: boolean;
  /**
   * A toggle indicating when and how to show the click and collect message.
   */
  showClickAndCollect?: string;
  /**
   * A boolean indicating whether to show free returns message.
   */
  showFreeReturns?: boolean;
  /**
   * A boolean indicating whether to show free returns message with restrictions.
   */
  showFreeReturnsWithRestrictions?: boolean;
  /**
   * A list of messages.
   */
  messageList?: string[];
  /**
   * A list of guarantees.
   */
  guarantees?: { title: string }[];
  /**
   * A boolean indicating whether to show the delivery message.
   */
  hideDeliveryMessage: boolean;

  returnsStartDate: string;

  returnsEndDate: string;

  show2ManDeliveryMessage?: boolean;

  twoManDeliveryPrice?: number;

  isBraExclusion?: boolean;
  /**
   * A boolean indicating whether to apply the highlighted background and padding design (Taupe 10 background, 16px padding).
   */
  hasHighlightedBackground?: boolean;
  /**
   * A boolean indicating whether the new typography styles are enabled.
   */
  isNewTypographyEnabled?: boolean;
};

export const DeliveryAndGuaranteesMessageUI = ({
  message,
  messageList = ["includedGuarantees", "deliveryHighlights"],
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  showClickAndCollect = "never",
  showFreeReturns = false,
  showFreeReturnsWithRestrictions = false,
  guarantees = [],
  hideDeliveryMessage,
  returnsStartDate,
  returnsEndDate,
  show2ManDeliveryMessage = false,
  twoManDeliveryPrice = undefined,
  isBraExclusion = false,
  hasHighlightedBackground = false,
  isNewTypographyEnabled = false,
}: Props) => {
  return (
    <div
      data-component="DeliveryAndGuaranteesMessage"
      className={cx("messageContainer", {
        highlightedBackground: hasHighlightedBackground,
        isNewTypographyEnabled,
      })}
    >
      {messageList.map((list) => {
        switch (list) {
          case "includedGuarantees":
            return <IncludedGuarantees key={list} guarantees={guarantees} />;
          case "deliveryHighlights":
            return (
              <DeliveryHighlights
                key={list}
                hideDeliveryMessage={hideDeliveryMessage}
                message={message}
                isClickAndCollectAvailable={isClickAndCollectAvailable}
                showClickAndCollect={showClickAndCollect}
                isOverClickAndCollectThreshold={isOverClickAndCollectThreshold}
                showFreeReturns={showFreeReturns}
                showFreeReturnsWithRestrictions={
                  showFreeReturnsWithRestrictions
                }
                returnsStartDate={returnsStartDate}
                returnsEndDate={returnsEndDate}
                show2ManDeliveryMessage={show2ManDeliveryMessage}
                twoManDeliveryPrice={twoManDeliveryPrice}
                isBraExclusion={isBraExclusion}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
